// src/services/fileSignaturesService.jsx

const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

// contentType should be like "accounts.userfile", "api.taskfile", ...
// objectId is the PK of that row.

// -----------------------------
// SIGN A FILE
// -----------------------------
export const signFile = async ({ contentType = 'accounts.userfile', objectId, code }) => {
  try {
    const url = new URL(`${API_BASE_URL}/documents-signatures/signatures/sign/`);

    const payload = {
      content_type: contentType,
      object_id: objectId,
      code: code,
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      },
      body: JSON.stringify(payload),
    });

    let data = null;
    try {
      data = await response.json();
    } catch {
      data = null;
    }

    return {
      success: response.ok,
      data: response.ok ? data : null,      // { id, file_repr, user, signed_at } from backend
      statusCode: response.status,
      error: response.ok ? null : (data?.detail || data),
    };
  } catch (error) {
    console.error('Error signing file', error);
    return {
      success: false,
      data: null,
      statusCode: 500,
      error: error.message,
    };
  }
};

// -----------------------------
// GET SIGNATURES FOR A FILE
// -----------------------------
export const fetchFileSignatures = async ({ contentType = 'accounts.userfile', objectId }) => {
  try {
    const url = new URL(`${API_BASE_URL}/documents-signatures/signatures/for-object/`);
    url.searchParams.set('content_type', contentType);
    url.searchParams.set('object_id', objectId);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      },
    });

    let data = null;
    try {
      data = await response.json();
    } catch {
      data = null;
    }

    return {
      success: response.ok,
      data: response.ok ? data : null,      // array of signatures
      statusCode: response.status,
      error: response.ok ? null : (data?.detail || data),
    };
  } catch (error) {
    console.error('Error fetching file signatures', error);
    return {
      success: false,
      data: null,
      statusCode: 500,
      error: error.message,
    };
  }
};
